export default {
      id: "sli-user2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-user2",
      toString: function () {
        return this.url;
      }
    }